<template>
  <b-modal id="filter-modal" v-model="auxValue" :width="600">
    <div class="modal-card-body">
      <div>
        <a id="button-close-modal" class="close-modal" @click="auxValue = false">
          <img src="@/ui/assets/img/plus-button.svg">
        </a>
      </div>
      <h4 class="modal-title has-text-centered">Filtros</h4>
      <div class="filters">
        <div class="row-filter">
          <div class="field">
            <label>Tipo de fecha</label>
            <div class="control">
              <b-select
                id="typeDate"
                v-model="filters.typeDate"
                expanded
                name="typeDate"
                size="is-small"
                rounded
                @input="validaTipoFecha()">
                <option v-for="item in dataFiltro" :key="item.id" :value="item.id">{{ item.name }}</option>
              </b-select>
            </div>
          </div>
          <div class="field">
            <label>Desde</label>
            <b-datepicker
              id="datepicker-from"
              v-model="filters.from"
              :disabled="validateDate"
              position="is-bottom-left"
              rounded
              size="is-small"
              locale="es-ES" />
          </div>
          <div class="field">
            <label>Hasta</label>
            <b-datepicker
              id="datepicker-to"
              v-model="filters.to"
              :disabled="validateDate"
              position="is-bottom-left"
              rounded
              size="is-small"
              locale="es-ES" />
          </div>
        </div>
        <div class="row-filter">
          <div class="field">
            <label>Nombre del cliente</label>
            <div class="control">
              <b-input
                id="search-input"
                v-model="filters.clientName"
                type="search"
                icon="search"
                icon-clickable
                placeholder="nombre del cliente"
                size="is-small"
                rounded />
            </div>
          </div>
          <div class="field">
            <label>Nombre de Inversionista</label>
            <div class="control">
              <b-select
                id="investor"
                v-model="filters.investor"
                expanded
                name="investor"
                size="is-small"
                rounded>
                <option v-for="item in dataInvestors" :key="item" :value="item">{{ item }}</option>
              </b-select>
            </div>
          </div>
          <div class="field">
            <label>Numero de RUT</label>
            <div class="control">
              <b-input
                id="search-input"
                v-model="filters.accountInvestor"
                type="search"
                icon="search"
                icon-clickable
                placeholder="nombre del rut"
                size="is-small"
                rounded />
            </div>
          </div>
        </div>
        <div class="row-filter">
          <div class="field">
            <label>Proveedor</label>
            <div class="control">
              <b-input
                id="search-input"
                v-model="filters.provider"
                type="search"
                icon="search"
                icon-clickable
                placeholder="proveedor"
                size="is-small"
                rounded />
            </div>
          </div>
          <div class="field">
            <label>Numero de CMF</label>
            <div class="control">
              <b-input
                id="search-input"
                v-model="filters.cmf"
                type="search"
                icon="search"
                icon-clickable
                placeholder="numero de cmf"
                size="is-small"
                rounded />
            </div>
          </div>
        </div>
        <div class="filter-restore buttons is-centered">
          <button class="button restore-fields is-button-secondary is-rounded" @click="restoreFilters">
            <span class="icon is-small">
              <i class="fas fa-undo-alt" />
            </span>
            <span>Restaurar filtros</span>
          </button>
          <button class="button perform-filter is-button-secondary is-rounded" @click="triggerFilter">
            <span>Filtrar</span>
          </button>
        </div>
      </div>
    </div>
  </b-modal>
</template>
<script>
import { getCollectingsInvestors } from '@/application/services/api-clients/query-stack';

export default {
  props: ['value', 'collectings'],
  data() {
    const date = new Date();
    return {
      auxValue: false,
      filters: {
        from: new Date(date.getFullYear(), date.getMonth(), 1),
        to: new Date(date.getFullYear(), date.getMonth() + 1, 1),
        report: '',
        clientName: '',
        investor: '',
        accountInvestor: '',
        provider: '',
        status: '',
        typeDate: ''
      },
      dataFiltro: [
        {
          id: 'Ninguno',
          name: 'Ninguno'
        },
        {
          id: 'createdat',
          name: 'Fecha de creacion'
        },
        {
          id: 'providerat',
          name: 'Fecha del proveedor'
        },
        {
          id: 'callbackat',
          name: 'Fecha del callback - Servipag'
        },
        {
          id: 'bankentrydate',
          name: 'Fecha de entrada bancaria'
        },
        {
          id: 'processedat',
          name: 'Fecha del proceso'
        },
        {
          id: 'consignedat',
          name: 'Fecha de la consignacion'
        }
      ],
      dataInvestors: [],
      validateDate: true
    };
  },
  watch: {
    value(val) {
      this.auxValue = val;
    },
    auxValue(val) {
      this.$emit('input', val);
    }
  },
  async mounted() {
    this.dataInvestors = await getCollectingsInvestors();
  },
  methods: {
    restoreFilters() {
      const date = new Date();
      this.filters = {
        from: new Date(date.getFullYear(), date.getMonth(), 1),
        to: new Date(date.getFullYear(), date.getMonth() + 1, 1),
        typeDate: '',
        report: '',
        clientName: '',
        investor: '',
        accountInvestor: '',
        provider: '',
        cmf: ''
      };
    },
    triggerFilter() {
      const { from, to } = this.filters;
      this.$emit('filter', {
        ...this.filters,
        from: from.toISOString().substring(0, 10),
        to: to.toISOString().substring(0, 10)
      });
      this.auxValue = false;
    },
    validaTipoFecha() {
      const { typeDate } = this.filters;

      if (typeDate === 'Ninguno' || typeDate === '') {
        this.validateDate = true;
      } else {
        this.validateDate = false;
      }
    }
  }
};
</script>
<style scoped>
.modal-title {
  margin: 1rem 2rem 3rem 2rem;
}
.modal-card-body {
  position: relative;
}
.modal-card-body .close-modal {
  position: absolute;
  right: 20px;
  top:20px;
  width: 40px;
}
.filter-restore {
  padding: 3rem 0;
}
.filters > .field {
  display: grid;
  gap: 1rem 2rem;
  grid-template-columns: minmax(100px, 1fr) minmax(100px, 1.5fr);
  align-items: center;
  justify-items: start;
  margin: 0 2rem 3rem 2rem;
}
.row-filter {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 10px;
}
.size-b-select {
  width: 100% !important;
}
.size-b-select > span {
  text-align: left;
  position: absolute;
  left: 30px;
}
.size-b-select > .icon {
  position: relative;
  transform: translate(30px, 0px);
}
</style>
